import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1201Model } from '../kymw1201.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * サイクル情報保存サービス
 * @export SaveCycleInfo
 * @class SaveCycleInfo
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class SaveCycleInfo extends PlessJsonResponderSub<any> {
  private model: KYMW1201Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof SaveCycleInfo
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        CycleInfoList: {
          combination: this.model.saveCycleInfo?.cycleInfoList.map(_ => {
            return {
              condition: {
                OrderCode: _.orderCode,
                MediumType: _.mediumType,
                PCode: _.pcode,
                ItemCode: _.itemCode,
                SpecialFeature: _.specialFeature,
                Folio: _.folio,
                Edlp: _.edlp,
                BuyerComment: _.buyerComment,
                CoopFlg142: _.coopFlg142 === true ? '1' : '0',
                CoopFlg163: _.coopFlg163 === true ? '1' : '0',
                CoopFlg185: _.coopFlg185 === true ? '1' : '0',
                CoopFlg240: _.coopFlg240 === true ? '1' : '0',
                CoopFlg210: _.coopFlg210 === true ? '1' : '0',
                CoopFlg302: _.coopFlg302 === true ? '1' : '0',
                CoopFlg515: _.coopFlg515 === true ? '1' : '0',
                CoopFlg451: _.coopFlg451 === true ? '1' : '0',
                PricePattern: _.pricePattern,
                PricePromotion: _.pricePromotion,
                BargainMarkFlg: _.bargainMarkFlg,
                KomaPromotion: _.komaPromotion,
                PromotionMark: _.promotionMark,
                AppearDiv: _.appearDiv,
                OrderNumQuotaCode: _.orderNumQuotaCode,
                MediumWPublishFlg: _.mediumWPublishFlg,
                CrossDecisionFlg: _.crossDecisionFlg,
                ThisTimeSupplyPrice: _.thisTimeSupplyPrice,
                ThisTimeCostPrice: _.thisTimeCostPrice,
                PlanNum: _.planNum,
              }
            }
          })
        },
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof SaveCycleInfo
   */
  execute(model: KYMW1201Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('saveCycleInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof SaveCycleInfo
   */
  success(data: any) {
    if (this.calbak) this.calbak();
  }
}
